var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "control",
            "title": "Solution",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" Smart Farm Solution ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    staticClass: "mb-0",
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v("The system monitors the state of each zone of the vertical farm and the root zones of the crops through its sensors and controls nutrients, irrigation, and environmental factors required for crop growth. It enables efficient vertical farm operation.")];
      },
      proxy: true
    }])
  }, [_c('b', [_vm._v("The Integrated Vertical Farm Control System")]), _vm._v(" "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("monitors a variety of cultivation factors of the vertical farm and controls the growth environment of crops ")])], 1), _c('page-section', {
    staticClass: "d-flex align-center min-h-lg-980px"
  }, [_c('div', {
    staticClass: "page-section__bg",
    staticStyle: {
      "background-image": "url(/images/sub/solution/plant/control-bg.jpg)"
    }
  }), _c('v-img', {
    staticClass: "d-md-none mx-auto",
    attrs: {
      "max-width": "350",
      "aspect-ratio": 700 / 2772,
      "src": "/images/sub/solution/plant/control-img-mo-en.png",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  }), _c('v-img', {
    staticClass: "d-none d-md-block mx-auto",
    attrs: {
      "max-width": "1200",
      "aspect-ratio": 1200 / 244,
      "src": "/images/sub/solution/plant/control-img-en.png",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  })], 1), _c('page-section', {
    staticClass: "grey lighten-5"
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "rounded": "",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "d-flex pa-30px pa-md-40px pa-lg-80px"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "1000",
      "aspect-ratio": 1000 / 634,
      "src": "/images/sub/solution/plant/control-img2.png"
    }
  })], 1)]), _c('div', {
    staticClass: "pt-30px pt-md-40px pt-lg-80px"
  }, [_c('v-row', {
    staticClass: "ma-n20px ma-md-n30px"
  }, [_c('v-col', {
    staticClass: "pa-20px pa-md-30px",
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left",
      "data-aos-delay": "100"
    }
  }, [_c('tit-wrap-sprout', [_vm._v(" Monitoring on the vertical farm and root zones ")]), _c('txt-item', {
    attrs: {
      "titleClass": "w-md-140px"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v("Measurement items")];
      },
      proxy: true
    }])
  }, [_vm._v(" Temperature, humidity, pH, EC, CO2, and artificial LED light ")])], 1), _c('v-col', {
    staticClass: "pa-20px pa-md-30px",
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left",
      "data-aos-delay": "200"
    }
  }, [_c('tit-wrap-sprout', [_vm._v(" Integrated Vertical Farm Control System ")]), _c('txt-item', {
    attrs: {
      "titleClass": "w-md-140px"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v("Control items")];
      },
      proxy: true
    }])
  }, [_vm._v(" Air-conditioning, ventilation, artificial LED lights, chiller, irrigation, and water level of cultivation shelves ")])], 1)], 1)], 1)], 1), _c('page-section', {
    staticClass: "page-section--last"
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "rounded": "",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1200 / 770,
      "content-class": "d-flex align-center justify-center"
    }
  }, [_c('div', {
    staticClass: "pa-30px pa-md-40px px-lg-80px"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "770",
      "width": _vm.$vuetify.breakpoint.lgAndUp ? '770' : '',
      "aspect-ratio": 770 / 376,
      "src": "/images/sub/solution/plant/control-img3.png"
    }
  }), _c('div', {
    staticClass: "pt-30px pt-md-40px pt-lg-60px"
  }, [_c('tit-wrap-small', {
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v("You can monitor information on the growth of crops and control the environmental factors via your PC and mobile device.")];
      },
      proxy: true
    }])
  }, [_vm._v(" Integrated IoT Environmental Control System ")])], 1)], 1)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }